export default {"src":"/_next/static/media/logo.58d3ca38.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};